import { forwardRef } from 'react';
import { cn } from '../../utils/cn';

const variantStyles = {
  primary:   'bg-brand-500 text-white hover:bg-brand-600 active:bg-brand-700',
  secondary: 'bg-accent-700 text-white hover:bg-accent-600 active:bg-accent-700',
  ghost:     'bg-transparent text-fg hover:bg-bg-muted',
  outline:   'border border-border bg-transparent text-fg hover:bg-bg-muted',
  danger:    'bg-status-error text-white hover:opacity-90',
};

const sizeStyles = {
  sm:   'h-8 px-3 text-sm rounded-md',
  md:   'h-10 px-4 text-sm rounded-lg',
  lg:   'h-12 px-6 text-base rounded-lg',
  icon: 'h-10 w-10 rounded-lg p-0',
};

export const Button = forwardRef(
  (
    {
      variant = 'primary',
      size = 'md',
      loading,
      iconLeft,
      iconRight,
      fullWidth,
      className,
      children,
      disabled,
      type = 'button',
      ...rest
    },
    ref,
  ) => (
    <button
      ref={ref}
      type={type}
      disabled={disabled || loading}
      className={cn(
        'inline-flex items-center justify-center gap-2 font-medium transition-colors',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        variantStyles[variant] ?? variantStyles.primary,
        sizeStyles[size] ?? sizeStyles.md,
        fullWidth && 'w-full',
        className,
      )}
      {...rest}
    >
      {loading ? (
        <span
          aria-hidden
          className="inline-block w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin"
        />
      ) : (
        iconLeft
      )}
      {children}
      {!loading && iconRight}
    </button>
  ),
);
Button.displayName = 'Button';